import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import themes from '../../theming/themes.js';
import { memo } from 'react';

var _templateObject;
var toggleSwitchContainerColors = {
  accent1: 'accent1Lightest',
  primary: 'primaryLightest',
  secondary: 'secondaryLightest'
};
var derriveBackgroundColor = function derriveBackgroundColor(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'secondary' : _ref$color,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$on = _ref.on,
    on = _ref$on === void 0 ? false : _ref$on,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? themes["default"] : _ref$theme;
  return on && !disabled ? theme.palette[toggleSwitchContainerColors[color]] : '#D8D8D8';
};
var derriveWidth = function derriveWidth(_ref2) {
  var _ref2$toggleSize = _ref2.toggleSize,
    toggleSize = _ref2$toggleSize === void 0 ? 'large' : _ref2$toggleSize;
  if (toggleSize === 'large') {
    return '62px';
  }
  if (toggleSize === 'medium') {
    return '48px';
  }
  return '36px';
};
var derriveHeight = function derriveHeight(_ref3) {
  var _ref3$toggleSize = _ref3.toggleSize,
    toggleSize = _ref3$toggleSize === void 0 ? 'large' : _ref3$toggleSize;
  if (toggleSize === 'large') {
    return '32px';
  }
  if (toggleSize === 'medium') {
    return '24px';
  }
  return '14px';
};
var derriveCursor = function derriveCursor(_ref4) {
  var _ref4$disabled = _ref4.disabled,
    disabled = _ref4$disabled === void 0 ? false : _ref4$disabled;
  return !disabled ? 'pointer' : 'not-allowed';
};
var derriveFocusBoxShadow = function derriveFocusBoxShadow(_ref5) {
  var _ref5$disabled = _ref5.disabled,
    disabled = _ref5$disabled === void 0 ? false : _ref5$disabled;
  return !disabled ? '0 0px .5rem #1B75BB' : null;
};
var ToggleSwitchContainer = styled('label')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: 16px;\n  display: inline-flex;\n  width: ", ";\n  height: ", ";\n  position: relative;\n  cursor: ", ";\n  transition: background-color 0.1s ease-in;\n\n  &:focus {\n    outline: none;\n    box-shadow: ", ";\n  }\n"])), derriveBackgroundColor, derriveWidth, derriveHeight, derriveCursor, derriveFocusBoxShadow);
var ToggleSwitchContainer$1 = /*#__PURE__*/memo(ToggleSwitchContainer);

export default ToggleSwitchContainer$1;
